import { authClient, API } from "../index";

export const countReviews = () => authClient().get(`${API}/review/count`);

export const getReviews = () => authClient().get(`${API}/review`);

export const getReviewById = (id) => authClient().get(`${API}/review/${id}`);

export const postReview = (body) => authClient().post(`${API}/review`, body);

export const updateReview = (id, body) =>
  authClient().put(`${API}/review/${id}`, body);

export const deleteReview = (id) => authClient().delete(`${API}/review/${id}`);
